module.exports = __webpack_public_path__ + "img/w20-b3.aad18f05.jpg";